<div class="w-full">
  <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
    <div class="flex items-center">
      <h6 mat-dialog-title class="font-semibold primary-font">{{'job.details.actions.description' | translate}}</h6>
    </div>
    <div class="flex items-center mr-1">
      <span [mat-dialog-close]="null" class="rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </span>
    </div>
  </div>
  <div class="flex flex-col zuper-dialog-body max-dialog-height overflow-y-auto zuper-scrollbar">
    <div>
      <form [formGroup]="updateDescriptionForm" class="cancelForm h-full overflow-y-none" autocomplete="off">
        <div class="w-full mb-4">
          <div class="mr-4">
            <div class="h-64 text-base mt-1">
              <text-editor
                  [editorData]="updateDescriptionForm?.controls?.job_description"
                  [options]="textEditorOptions"
                  style="font-size: 14px;"
                  >
              </text-editor>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
    
    <div class="flex justify-around space-x-4 bg-gray-50">
        <button type="button" mat-stroked-button  [mat-dialog-close]="null" class="px-6 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">{{'cancel.text' | translate}}</button>
        <button (click)="submit()" class="min-w-24 px-6 items-center btn-small py-2 border b-1 shadow-sm text-base text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary">
          <span>{{'update' | translate}}</span>
        </button>
    </div>
  </div>
</div> 